import { loadMetrika } from "./metrika.js";

/** Ключ решения читателя. Значение хранится с первой версии баннера, не менять. */
const CONSENT_KEY = "cookieConsent";

/** Кнопка плашки: разметку задаёт класс компонента, а не инлайновый стиль. */
function button(label, variant) {
  const element = document.createElement("button");
  element.type = "button";
  element.className = `btn btn--${variant} btn--sm`;
  element.textContent = label;
  return element;
}

/**
 * Плашка согласия на cookie.
 *
 * Метрика подключается только после «Принять»: до ответа читателя внешних
 * скриптов на странице нет.
 */
(function () {
  let consent = null;
  try {
    consent = localStorage.getItem(CONSENT_KEY);
  } catch {
    // Приватный режим или запрет на хранилище: спросим ещё раз в другой заход.
  }

  if (consent === "accepted") {
    loadMetrika();
    return;
  }
  if (consent === "declined") return;

  const banner = document.createElement("div");
  banner.id = "cookie-consent";
  banner.className = "cookie-consent";
  // Иначе плашка попадёт в снапшот Turbo и вернётся на уже отвеченной странице.
  banner.dataset.turboTemporary = "";

  const text = document.createElement("p");
  text.className = "cookie-consent__text";
  text.textContent = "Мы используем cookie для улучшения работы сайта.";

  const actions = document.createElement("div");
  actions.className = "cookie-consent__actions";

  const accept = button("Принять", "primary");
  const decline = button("Отклонить", "outline");
  const info = button("Подробнее", "ghost");

  actions.append(accept, decline, info);
  banner.append(text, actions);
  document.body.append(banner);

  function remember(choice) {
    try {
      localStorage.setItem(CONSENT_KEY, choice);
    } catch {
      // Не запомнили — спросим в следующий раз.
    }
    banner.remove();
  }

  accept.addEventListener("click", () => {
    remember("accepted");
    loadMetrika();
  });

  decline.addEventListener("click", () => remember("declined"));
  info.addEventListener("click", () => {
    window.location.href = "/cookie-policy";
  });
})();
